// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"aa9a918f","470":"7cef1914","716":"9abf3e29","963":"3cacbe75"}[chunkId] + ".chunk.js";
};